<template>
  <div class="no-find">
    <p>没有找到对应的页面</p>
    <el-button type="primary" class="return-btn" @click="returnIndex">返回首页</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    returnIndex () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scope>
@import '$styles/global.scss';

.no-find{
  height: 100%;
  width: 100%;
  @include flex-box();

  p{
    width: 100%;
    margin-bottom: 20px;
    font-size: 26px;
    text-align: center;
  }

  .return-btn{
    width: 200px;
  }
}
</style>
